
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy/simple-quote",
      function () {
        return require("private-next-pages/privacy-policy/simple-quote.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy/simple-quote"])
      });
    }
  